/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmacoDto } from '../../models/farmaco-dto';

export interface FarmacosControllerBuscarFarmacos$Params {

/**
 * Término de búsqueda para filtrar fármacos por nombre
 */
  query: string;

/**
 * Filtrar por tipo de fármaco (opcional)
 */
  tipo?: string;

/**
 * Límite máximo de resultados (opcional, por defecto 20, máximo 50)
 */
  limit?: string;
}

export function farmacosControllerBuscarFarmacos(http: HttpClient, rootUrl: string, params: FarmacosControllerBuscarFarmacos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmacoDto>>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerBuscarFarmacos.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('tipo', params.tipo, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FarmacoDto>>;
    })
  );
}

farmacosControllerBuscarFarmacos.PATH = '/api/farmacos/busqueda';
